import { describeKnowledgeApiError } from 'utils/knowledgeErrors';
import { LoadingOutlined } from '@ant-design/icons';
import { queryItemList } from '@knowledge/common/components/ItemSelectV2/api';
import { filterByBindItem } from '@knowledge/common/components/ItemSelectV5/components/QuickSelect';
import { Spu, SpuList } from '@knowledge/common/components/SpuBasic';
import { useTranslate } from '@tolgee/react';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import { SupplementalKnowledgeAiReplyKnowledge } from 'services/api/supplementKnowledge';

function ItemList({ bindItem }: { bindItem: SupplementalKnowledgeAiReplyKnowledge['bindItem'] }) {
  const { t } = useTranslate();

  const { loading, data } = useRequest(
    () => {
      return queryItemList({
        keyword: bindItem.map((_) => _.spuId).join(','),
        keywordType: 2,
        pageNo: 1,
        pageSize: bindItem.length,
        platformStoreScope: [],
        tagId: [],
        storeType: 0,
      }).then((res) => filterByBindItem(res.itemList, bindItem));
    },
    {
      refreshDeps: [bindItem],
      onError: (knowledgeError) => message.error(
          describeKnowledgeApiError(
            knowledgeError,
            undefined,
            t('phrase.获取数据失败，请稍后再试'),
          ),
        ),
    },
  );

  return (
    <SpuList>
      {loading ? (
        <LoadingOutlined />
      ) : (
        data?.map((spu) => {
          const { itemName, imageUrl: [imageUrl] = [], skuInfo = [] } = spu;
          const newSpu: any = {};
          newSpu.imageUrl = imageUrl;
          newSpu.skus = skuInfo;
          newSpu.title = itemName;
          return (
            <li key={spu.internalItemId}>
              <Spu spu={newSpu} />
            </li>
          );
        })
      )}
    </SpuList>
  );
}

export default ItemList;
